import { Button, Modal } from 'antd';
import { getIP } from 'api/common';
import { getAreaCodeByCurrentGeo } from 'api/common';
import { MediaQueryContext, SiteContext } from 'libs/contexts';
import { strToObj } from 'libs/utils';
import { useContext, useEffect, useState } from 'react';
import { cls } from 'reactutils';
import { LAST_LOCATION_KEY } from './AreaCascader';

// 判断区域编码是否相等
function isSameFirst16Code(a, b) {
  return a.slice(0, 16) === b.slice(0, 16);
}

// 获取当前的定位信息
export default function IPSwitchModal({ fullAreaName, onChange, value }) {
  const { isMobile } = useContext(MediaQueryContext);
  const [changeAreaVisible, setChangeAreaVisible] = useState(false);
  const [currentIPInfo, setCurrentIPInfo] = useState(null);
  const site = useContext(SiteContext);
  // 初始为undefined
  const currentAreaName = !isMobile ? fullAreaName : fullAreaName.split('/')[1];

  const getLocationInCookie = () => {
    // 根据租户code 拼接cookie key
    const tenantCode = site?.tenantCode ?? 'pazc';
    const cookie = strToObj(document.cookie);
    const AREA_CODE_KEY = `${tenantCode}_area_code`;
    const locationInCookie = cookie[AREA_CODE_KEY];
    return locationInCookie;
  };

  // 基于IP定位
  // 基于这段逻辑改造，微信环境下使用经纬度
  useEffect(() => {
    async function getCurrentGeoPostion() {
      // 微信环境，包含公众号、小程序、企业微信
      const isWxEnv = /MicroMessenger/i.test(navigator.userAgent);
      const actionHandle = isWxEnv ? getAreaCodeByCurrentGeo : getIP;
      try {
        const currentIPRes: any = await actionHandle();
        if (currentIPRes?.data?.areaCode) {
          setCurrentIPInfo(currentIPRes.data);
        }
      } catch (error) {}
    }

    getCurrentGeoPostion();
  }, []);

  useEffect(() => {
    const lastLocation = localStorage.getItem(LAST_LOCATION_KEY);
    const currentLocationInCookie = getLocationInCookie();

    if (!lastLocation) {
      // setLastLocation to currentIP for the frist time
      if (currentIPInfo) {
        localStorage.setItem(LAST_LOCATION_KEY, currentIPInfo.areaCode);
      }
      // 对比「IP定位」与「浏览器定位」然后显示，地址切换弹窗
      if (
        currentIPInfo &&
        currentLocationInCookie &&
        !isSameFirst16Code(currentLocationInCookie, currentIPInfo.areaCode)
      ) {
        setChangeAreaVisible(true);
      }
    } else {
      // 「当前IP定位」与「缓存中IP定位」不同、且「当前IP」与「浏览器定位」不同
      if (
        currentIPInfo &&
        currentLocationInCookie &&
        !isSameFirst16Code(lastLocation, currentIPInfo.areaCode) &&
        !isSameFirst16Code(currentLocationInCookie, currentIPInfo.areaCode)
      ) {
        setChangeAreaVisible(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIPInfo, value]);

  const afterClose = () => {
    // update localStorage to current ip when close the modal
    localStorage.setItem(LAST_LOCATION_KEY, currentIPInfo.areaCode);
  };

  //用户点击「切换」后，才切换至新的「IP定位地址」
  const switchToIP = () => {
    setChangeAreaVisible(false);
    localStorage.setItem(LAST_LOCATION_KEY, currentIPInfo.areaCode);
    onChange(currentIPInfo);
  };

  return (
    <Modal
      visible={changeAreaVisible}
      onCancel={() => {
        setChangeAreaVisible(false);
      }}
      footer={null}
      afterClose={afterClose}
      maskClosable={false}
      wrapClassName={isMobile ? 'mobile-ip-modal' : 'web-ip-modal'}
      centered={isMobile}
    >
      <div className={cls('modal-container')}>
        <p className="city">识别到您在{currentIPInfo?.name}</p>
        <div className="btns">
          <Button onClick={switchToIP} type="primary">
            切换到{currentIPInfo?.name}
          </Button>
          <Button onClick={() => setChangeAreaVisible(false)}>继续浏览{currentAreaName}</Button>
        </div>
      </div>
      <style jsx>{`
        .btns {
          display: flex;
          flex-direction: column;
          min-width: 200px;
        }

        .btns :globle(button) {
          margin-bottom: 15px;
        }

        .city {
          font-weight: 500;
          font-size: 16px;
          margin-top: 20px;
        }

        :global(.mobile-ip-modal .ant-modal) {
          width: 80% !important;
        }
        :global(.web-ip-modal .ant-modal) {
          width: 400px !important;
        }

        .modal-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      `}</style>
    </Modal>
  );
}
